<template>
  <div
    :style="{
      backgroundColor: isDarkTheme ? mainBgColor : '#eeeeee',
      padding: '10px',
      // paddingTop: '0px',
      paddingTop: '20px',
      position: 'relative',
      bottom: '20px',
      minHeight: '100vh',
      height: 'auto'
    }"
    id="wallet"
  >
    <div class="padding-5"></div>
    <div class="wallet-cards-wrapper">
      <div
        v-if="walletData.length || referralData.length"
        :style="{
          backgroundColor: isDarkTheme ? shadowBgColor : '#eeeeee',
          padding: isDarkTheme && '10px',
          borderRadius: isDarkTheme && '10px'
          // borderTopLeftRadius: '10px',
          // borderTopRightRadius: '10px'
        }"
      >
        <div
          class="wallet-wrapper box-shadow margin-bottom-10"
          v-for="wl in walletData"
          style="border-radius: 10px"
        >
          <div
            class="wallet-header-bg padding-10"
            :style="{
              backgroundColor: isDarkTheme ? walletCardColor : '#eeeeee',
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px'
              // borderRadius: '10px'
            }"
          >
            <div class="align-hor center-ver space-between bg-grey">
              <div class="align-hor center-ver">
                <div v-if="wl.reward_icon">
                  <img
                    class="semi-medium-icon margin-right-5"
                    :src="wl.reward_icon"
                    alt="cash-reward"
                  />
                </div>
                <div class="text-left">
                  <div
                    class="text-semi-small"
                    :style="{ color: isDarkTheme ? extraTextColor : '#323232' }"
                  >
                    Balance
                  </div>
                  <div
                    class="font-bold"
                    :style="{
                      color: isDarkTheme ? walletSubHeadingColor : '#373535'
                    }"
                  >
                    {{ formatReward(wl.reward_type, wl.balance, true) }}
                  </div>
                </div>
              </div>
              <div
                class="wrap align-hor center-ver center-hor padding-0510 pointer"
                v-if="wl.is_redeemable || wl.reward_type == 'Cash'"
                :style="{
                  background: wl.is_redeemable
                    ? (isDarkTheme ? buttonBGColor : bgTheme)
                    : '#CCCCCC',
                  color: isDarkTheme ? headingTextColor : '#ffffff'
                }"
                @click="
                  wl.is_redeemable
                    ? redirectTo(
                        wl.reward_type == 'Cash' ? 'redeem' : 'gift-cards',
                        { bal: formatReward(wl.reward_type, wl.balance, true) }
                      )
                    : ''
                "
                style="border-radius: 15px; font-size: 12px"
              >
                <div>
                  Redeem
                </div>
              </div>
            </div>
            <div
              class="text-left text-semi-small"
              v-if="wl.wallet_message && wl.wallet_message != ''"
              :style="{
                color: isDarkTheme ? extraTextColor : '#585957',
                marginLeft: '35px'
              }"
            >
              {{ wl.wallet_message }}
            </div>
          </div>
          <div
            class="bg-light"
            :style="{
              backgroundColor: isDarkTheme ? walletCardColor : '#ffffff'
            }"
          >
            <div
              class="align-hor center-ver space-between padding-vertical-5"
              :style="{
                backgroundColor: isDarkTheme ? walletInnerCardColor : '#ffffff',
                padding: ' 10px',
                borderBottom: isDarkTheme
                  ? '3px dotted' + walletCardColor
                  : '3px dotted #eeeeee'
              }"
            >
              <p
                style="
                  font-weight: 700;
                  margin: 10px 0px !important;
                  
                "
              >
                Total Earned
              </p>
              <p style="margin: 10px 0px !important; color: #757575;">
                {{ formatReward(wl.reward_type, wl.total_earned, true) }}
              </p>
            </div>
            <div
              class="align-hor center-ver space-between padding-vertical-5 padding-horizontal-10"
              :style="{
                backgroundColor: isDarkTheme ? walletInnerCardColor : '#ffffff',
                padding: ' 10px'
              }"
            >
              <p
                style="
                  font-weight: 700;
                  margin: 10px 0px !important;
                "
              >
                Total Redeemed
              </p>
              <p style="margin: 10px 0px !important; color: #757575;">
                {{ formatReward(wl.reward_type, wl.total_redeemed, true) }}
              </p>
              <!--              <p v-else>0</p>-->
            </div>
          </div>
          <div
            class="wallet-header-bg padding-10 text-large text-underline text-right pointer"
            :style="{
              backgroundColor: isDarkTheme ? walletCardColor : '#eeeeee',
              borderBottomLeftRadius: '10px',
              borderBottomRightRadius: '10px'
            }"
            v-on:click="
              redirectTo('transactions', {
                type: wl.reward_type,
                is_redeemable: wl.is_redeemable,
                active_currency: active_currency.label
              })
            "
            style="font-size: 14px; font-weight: 400;"
          >
            All Transaction
          </div>
        </div>

        <div
          class="wallet-wrapper box-shadow radius-5 margin-bottom-10"
          v-if="referralData.length"
          style="border-radius: 10px;"
        >
          <div
            :style="{
              backgroundColor: isDarkTheme ? walletCardColor : '#eeeeee',
              borderTopLeftRadius: '10px',
              borderTopRightRadius: '10px'
            }"
            class="wallet-header-bg padding-10"
          >
            <div class="align-hor center-ver space-between bg-grey">
              <div class="align-hor center-ver">
                <div class="align-hor center-ver">
                  <img
                    class="extra-medium-icon margin-right-5"
                    src="@/assets/referral.svg"
                    alt="cash-reward"
                  />
                </div>
                <div class="text-left">
                  <div class="font-bold">Referrals</div>
                </div>
              </div>
            </div>
          </div>
          <div
            :style="{
              backgroundColor: isDarkTheme ? walletInnerCardColor : '#ffffff'
            }"
            class="bg-light padding-10"
          >
            <div
              class="align-hor center-ver space-between"
              v-for="ref in referralData"
              :key="ref"
            >
              <p
                style="text-align: left; margin: 10px 0px !important; "
              >
                Total {{ ref.prize_type }} Earned from Referrals
              </p>
              <p style="margin: 10px 0px !important; color: #757575;">
                {{ formatReward(ref.prize_type, ref.total_value, true) }}
              </p>
            </div>
          </div>
          <div
            :style="{
              backgroundColor: isDarkTheme ? walletCardColor : '#eeeeee',
              borderBottomLeftRadius: '10px',
              borderBottomRightRadius: '10px'
            }"
            class="wallet-header-bg padding-10 text-small text-underline text-right pointer"
            @click="redirectTo('referrals')"
            style="font-size: 14px; font-weight: 500;  "
          >
            History
          </div>
        </div>
      </div>

      <div
        class="wallet-wrapper box-shadow margin-bottom-10"
        v-if="walletData.length == 0 && referralData.length == 0 && showShimmer"
        v-for="$i in 2"
        :key="$i"
      >
        <div
          class="align-hor center-ver space-between wallet-header-bg padding-10"
        >
          <div class="w50">
            <div class="align-hor center-ver margin-bottom-10">
              <div class="w20 margin-right-10">
                <div class="wrapper">
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                  <div class="comment animate"></div>
                </div>
              </div>
              <div class="w40">
                <div class="wrapper">
                  <div class="comment animate margin-bottom-5"></div>
                  <div class="comment animate"></div>
                </div>
              </div>
            </div>
            <div class="wrapper">
              <div class="comment animate"></div>
            </div>
          </div>
          <div class="w20">
            <div class="wrapper">
              <div class="comment animate"></div>
              <div class="comment animate"></div>
            </div>
          </div>
        </div>

        <div
          class="align-hor center-ver space-between bg-light padding-10 bottom-border"
          v-for="$j in 2"
          :key="$j"
        >
          <div class="w40">
            <div class="padding-horizontal-10">
              <div class="wrapper">
                <div class="comment animate"></div>
              </div>
            </div>
          </div>
          <div class="w10">
            <div class="wrapper">
              <div class="comment animate"></div>
            </div>
          </div>
        </div>

        <div class="align-hor center-ver end-hor wallet-header-bg padding-10">
          <div class="w20">
            <div class="wrapper">
              <div class="comment animate"></div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="bg-light bottom-radius-5 padding-20 margin-bottom-10 pos-rel box-shadow align-ver center-hor center-ver"
        style="min-height: 80vh"
        v-if="
          walletData.length == 0 && referralData.length == 0 && !showShimmer
        "
      >
        <img
          class="extra-large-icon margin-bottom-20"
          src="@/assets/no-data.svg"
        />
        <div>Nothing to show</div>
      </div>
    </div>
  </div>
</template>

<script>
import { globals } from "@/mixins/globals";
import axios from "axios";
export default {
  mixins: [globals],
  data() {
    return {
      walletData: [],
      referralData: [],
      is_shimmer: true,
      active_currency: {}
    };
  },

  beforeMount() {
    this.loadDataFromCookie();
  },
  computed: {
    isDarkTheme() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null; // fallback
    },
    shadowBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.shadowBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.shadowBgColor;
      }
      return null; // fallback
    },
    buttonBGColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.buttonBGColor
      ) {
        return this.$store.state.sdkEvent.themeColors.buttonBGColor;
      }
      return null; // fallback
    },
    walletCardColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.walletCardColor
      ) {
        return this.$store.state.sdkEvent.themeColors.walletCardColor;
      }
      return null; // fallback
    },
    walletInnerCardColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.walletInnerCardColor
      ) {
        return this.$store.state.sdkEvent.themeColors.walletInnerCardColor;
      }
      return null; // fallback
    },

    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    headingTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null; // fallback
    },
    walletSubHeadingColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.walletSubHeadingColor
      ) {
        return this.$store.state.sdkEvent.themeColors.walletSubHeadingColor;
      }
      return null; // fallback
    },
    extraTextColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.extraTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.extraTextColor;
      }
      return null; // fallback
    },
    mainBgColor() {
      // ✅ Guard for sdkEvent and themeColors
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.mainBgColor
      ) {
        return this.$store.state.sdkEvent.themeColors.mainBgColor;
      }
      return null; // fallback
    },

    allTransactions: function() {
      return this.transactions;
    },
    showShimmer: function() {
      return this.is_shimmer;
    }
  },
  methods: {
    getWalletData() {
      axios
        .all([this.getWalletInfo()])
        .then(
          axios.spread(resp => {
            if (resp.data.success) {
              var data = resp.data;
              if (
                (data.wallet_data && data.wallet_data.length > 0) ||
                (data.referral_data && data.referral_data.length > 0)
              ) {
                this.walletData = resp.data.wallet_data.filter(item => {
                  return item.reward_type != "Stamps";
                });
                this.referralData = resp.data.referral_data;
                this.active_currency = resp.data.active_currency;
                this.$store.dispatch(
                  "updateActiveCurrency",
                  resp.data.active_currency
                );
              } else {
                this.is_shimmer = false;
              }
            } else {
              this.is_shimmer = false;
            }
          })
        )
        .catch(err => {});
    }
  },
  created() {
    var store_state = this.$store.state;
    store_state.headTitle = "Wallet";
    store_state.showHeader = true;
    store_state.showHistory = false;
    store_state.showWallet = false;
    store_state.user.headerBalance.show = false;
    this.loadDataFromCookie();
    this.getWalletData();
  }
};
</script>

<style>
.small-reward-icon {
  width: 20px;
  margin-right: 5px;
}

.transaction-bg {
  background: #ffffff;
  margin-left: 5px;
  margin-right: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.wallet-header-bg {
  background: #f7f7f7;
}
</style>
